import { Constant } from 'app/config/constants';
import { FIELD_COMPONENT, MODULE_NAME } from './../../config/constants';
import { CommonService } from './../../service/common.service';
import { DataService } from './../../service/data.service';
import { MenuActionService } from './../../service/menu-action.service';
import { ActionState } from './../../config/action-state';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'menu-gtfs',
  templateUrl: './menu-gtfs.component.html',
  styleUrls: ['./menu-gtfs.component.scss']
})
export class MenuGtfsComponent implements OnInit {
  FIELD_COMPONENT = FIELD_COMPONENT;
  MODULE_NAME = MODULE_NAME;
  isCheckWidthMenu: boolean;
  isCheckDisplay: boolean;
  isCheckSetting: boolean;
  isCheckDelivery: boolean;
  isEditingTimetable: boolean;
  isPreviewTimetable: boolean;
  isShowFreeArea: boolean;
  isShowURLArea: boolean;
  isDisabledButtonSort: boolean;
  isClearField: boolean;
  isChosenTabCalendar: boolean;
  isRecordsTimetableMax: boolean;
  isRoot: boolean;

  /**
   * action states for module 1
   */
  actionState1: ActionState = new ActionState('', true, true, true, true, true, true, true, false, false);

  constructor(private menuActionService: MenuActionService, private dataService: DataService, private commonService: CommonService) {
    this.dataService.currentData.subscribe(data => {
      switch (data[0]) {
        case Constant.IS_ROOT: {
          this.isRoot = <boolean>data[1];
          break;
        }
      }
    });
  }

  ngOnInit(): void {
    this.handlingDisplayMenu();
  }
  /**
   * execute action for Api Definition in menu
   * @param {string} moduleName current module name
   */
  apiDefinition(moduleName: string) {
    this.menuActionService.apiDefinition(moduleName);
  }

  /**
   * execute action for Update in menu
   * @param {string} moduleName current module name
   */
  update(moduleName: string) {
    this.menuActionService.update(moduleName);
  }

  /**
   * handle  menu  when resize screen
   */
  handlingDisplayMenu() {
    this.isCheckWidthMenu = true;
    this.isCheckDisplay = true;
    this.isCheckSetting = true;
    this.isCheckDelivery = true;
    this.dataService.currentData.subscribe(data => {
      if (data[0] == 'checkSettingTimetable') {
        this.isCheckSetting = <boolean>data[1];
      }
      if (data[0] == 'checkDisplayTimetable') {
        this.isCheckDisplay = <boolean>data[1];
      }
      if (data[0] == 'checkDeliveryTimetable') {
        this.isCheckDelivery = <boolean>data[1];
      }
      this.isCheckWidthMenu = this.isCheckDisplay && this.isCheckDelivery && this.isCheckSetting;
    });
  }

  /**
   * execute action for Update Timing in menu
   * @param {string} moduleName current module name
   */
  public updateTextHighlightSetting(moduleName: string) {
    this.menuActionService.updateTextHighlightSetting(moduleName);
  }
}
